"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsoLocale = exports.getValidIsoLanguage = exports.getValidLanguage = exports.formatPrice = exports.getTranslation = exports.personalizeText = exports.interpolateVariables = exports.DEFAULT_DATE_LOCALE = exports.DEFAULT_LANGUAGE = exports.DATE_LOCALES = exports.LANGUAGES = exports.LOCALE_REGEX = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./constants"), exports);
const constants_1 = require("../report/constants");
// Taken from acci-locale
exports.LOCALE_REGEX = /^\/(?<language>[a-z]{2})(?:-(?<country>[a-z]{2}))?(\/|$)/;
var LANGUAGES;
(function (LANGUAGES) {
    LANGUAGES["fr"] = "fr";
    LANGUAGES["en"] = "en";
})(LANGUAGES = exports.LANGUAGES || (exports.LANGUAGES = {}));
var DATE_LOCALES;
(function (DATE_LOCALES) {
    DATE_LOCALES["fr"] = "fr-CA";
    DATE_LOCALES["en"] = "en-CA";
})(DATE_LOCALES = exports.DATE_LOCALES || (exports.DATE_LOCALES = {}));
exports.DEFAULT_LANGUAGE = LANGUAGES.fr;
exports.DEFAULT_DATE_LOCALE = DATE_LOCALES.fr;
/**
 * Interpolates `{variableName}` placeholders and optional plural forms (`singular|plural` + `count`).
 * Aligned with `shared/acci-utils/src/translation/index.ts`.
 */
function interpolateVariables(text, variables, count) {
    let formatted = text;
    let vars = variables;
    if (typeof count === 'number') {
        const textSplit = formatted.split('|');
        formatted = count > 1 && textSplit[1] ? textSplit[1] : textSplit[0];
        vars = { ...vars, count };
    }
    if (vars) {
        Object.entries(vars).forEach(([name, value]) => {
            formatted = formatted.replace(new RegExp(`\\{${name}\\}`, 'g'), String(value));
        });
    }
    return formatted;
}
exports.interpolateVariables = interpolateVariables;
function isObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function personalizeText(options) {
    const { text, personType, personGender, variables, count } = options;
    if (typeof text === 'string')
        return interpolateVariables(text, variables, count);
    if (!isObject(text))
        return String(text);
    let msg = text;
    const deepKeys = [personType, 'other', personGender || '-', constants_1.DEFAULT_GENDER];
    for (const k of deepKeys) {
        if (!isObject(msg))
            break;
        if (k && k in msg)
            msg = msg[k];
    }
    if (typeof msg === 'string')
        return interpolateVariables(msg, variables, count);
    return String(msg);
}
exports.personalizeText = personalizeText;
/**
 * Nested keys with dot notation, variable interpolation, plural `|`, and default language fallback.
 * Aligned with `shared/acci-utils/src/translation/index.ts`.
 */
function getTranslation(translationObject, language, key, variables, count) {
    const validLang = getValidLanguage(language) || exports.DEFAULT_LANGUAGE;
    const parent = translationObject[validLang] || translationObject[exports.DEFAULT_LANGUAGE];
    const keys = key.split('.');
    const getText = (obj) => {
        let current = obj;
        for (const k of keys) {
            if (typeof current !== 'object' || current === null || !(k in current)) {
                return undefined;
            }
            current = current[k];
        }
        return current;
    };
    let text = getText(parent) || getText(translationObject[exports.DEFAULT_LANGUAGE]);
    if (typeof text === 'string')
        text = interpolateVariables(text, variables, count);
    return text;
}
exports.getTranslation = getTranslation;
function formatPrice(options) {
    const { number, locale, minimumFractionDigits = 2 } = options;
    const currency = options.currency.toUpperCase();
    const formattedPrice = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits,
    }).format(number);
    return replaceDollar(formattedPrice, ' $ ').trim();
}
exports.formatPrice = formatPrice;
function replaceDollar(string, replacement) {
    return string.replace(/[A-Za-z\s]*\$[A-Za-z\s]*/g, replacement);
}
function getValidLanguage(language) {
    if (!language || !Object.values(LANGUAGES).includes(language))
        return;
    return language;
}
exports.getValidLanguage = getValidLanguage;
function getValidIsoLanguage(language) {
    return !language || !Object.values(LANGUAGES).includes(language)
        ? exports.DEFAULT_LANGUAGE
        : language;
}
exports.getValidIsoLanguage = getValidIsoLanguage;
function getIsoLocale(isoLanguage, country) {
    return [getValidIsoLanguage(isoLanguage), country].join('-');
}
exports.getIsoLocale = getIsoLocale;
//# sourceMappingURL=index.js.map